export async function createUserLeaderboardPreferencesView(userDb: any, logger: any) {
  logger.info('create leaderboard preferences view index');

  const doc = {
    _id: '_design/user-leaderboard-preferences',
    views: {
      'leaderboard-preference': {
        map: `function (doc) {
          if (doc.leaderboardPreferences) {
            const leaderboardPreferences = doc.leaderboardPreferences.leaderboardPreferences;
            Object.keys(leaderboardPreferences).forEach(leaderboardId => {
              emit([leaderboardId, doc.uid, leaderboardPreferences[leaderboardId]], 1);
            });
          }
        }`,
        reduce: '_count',
      },
    },
  };

  await userDb.put(doc);
}
